import Processing from './Processing';

export default Processing;